// import { baim } from '@b2x/baim';
import { b2x } from '@b2x/react/src';

import { Container } from '../Container';
import { t } from '../i18n/i18n';
import { Page } from './Page';

export interface HomePageProps {}

export const HomePage = (props: HomePageProps) => {
  const { getFixedPagePath, getPagePath } = b2x.useAppStaticContext();

  // React.useEffect(() => {
  //   baim.sendEvent({
  //     coupon: 'SUMMER_SALE',
  //     currency: 'USD',
  //     event: 'purchase',
  //     shipping: 5.99,
  //     tax: 4.9,
  //     transaction_id: 'T_12345_1',
  //     value: 30.03,
  //   });
  // }, []);

  return (
    <Page>
      <Container>
        <h1 className="my-4">{t('welcome')}</h1>
        <h5 className="mb-4">
          Per iniziare, dai uno sguardo alla pagina{' '}
          <b2x.router.Link to={getFixedPagePath('template')}>Template</b2x.router.Link>.
        </h5>
        <h6>Altre pagine pronte all uso:</h6>
        <ul>
          <li>
            <b2x.router.Link to={getPagePath('SITE_CUSTOMER_CARE')}>Customer care</b2x.router.Link>
          </li>
          <li>
            <b2x.router.Link to={getPagePath('SITE_LEGAL_AREA')}>Area legale</b2x.router.Link>
          </li>
          <li>
            <b2x.router.Link to={getPagePath('SITE_ACCOUNT')}>Account</b2x.router.Link>
          </li>
          <li>
            <b2x.router.Link to={getFixedPagePath('cart')}>Carrello</b2x.router.Link>
          </li>
          <li>
            <b2x.router.Link to={getFixedPagePath('checkout')}>Checkout</b2x.router.Link>
          </li>
        </ul>
      </Container>
    </Page>
  );
};
